import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Pressable, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { type SelectFilterOption } from '../../select-filter';

const itemStyles = xcss({
	cursor: 'default',
	width: '100%',
	textAlign: 'left',
	borderLeftWidth: 'border.width.selected',
	borderLeftStyle: 'solid',
	borderColor: 'color.border.inverse',
	backgroundColor: 'color.background.neutral.subtle',
	':hover': {
		borderColor: 'color.border.selected',
		backgroundColor: 'color.background.neutral.subtle.hovered',
	},
});

const itemStylesOld = xcss({
	cursor: 'default',
	borderLeftWidth: 'border.width.selected',
	borderLeftStyle: 'solid',
	borderColor: 'color.border.inverse',
	':hover': {
		borderColor: 'color.border.selected',
		backgroundColor: 'color.background.neutral.subtle.hovered',
	},
});

const insideItemStyles = xcss({
	marginLeft: 'space.negative.025',
	font: token('font.body'),
});

const itemHoveredStyles = xcss({
	borderColor: 'color.border.selected',
	backgroundColor: 'color.background.neutral.subtle.hovered',
});

const itemSelectedStyles = xcss({
	borderColor: 'color.border.selected',
	backgroundColor: 'color.background.selected',
});

type SelectItemProps = {
	option: SelectFilterOption;
	onClick: () => void;
	hovered?: boolean;
};

const DateOption = ({ option, hovered, onClick }: SelectItemProps): React.JSX.Element =>
	fg('rovo_search_last_modified_filter') ? (
		<Pressable
			role="menuitem"
			xcss={[itemStyles, option.isSelected && itemSelectedStyles, hovered && itemHoveredStyles]}
			key={option.label}
			onClick={onClick}
			paddingInline="space.150"
			paddingBlock="space.075"
			tabIndex={-1}
		>
			<Box xcss={insideItemStyles}>{option.label}</Box>
		</Pressable>
	) : (
		// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
		<Box
			xcss={[itemStylesOld, option.isSelected && itemSelectedStyles, hovered && itemHoveredStyles]}
			key={option.label}
			onClick={onClick}
			paddingInline="space.150"
			paddingBlock="space.075"
		>
			<Box xcss={insideItemStyles}>{option.label}</Box>
		</Box>
	);

export default DateOption;
